import React, { Fragment, useEffect, useState } from 'react';
import { httpClient } from "util/Api";
import { message, Space, Spin } from 'antd';
import CircularProgress from "components/CircularProgress";
import DefaultSection from './DefaultSection'
import * as globalFunction from 'util/GlobalFunction';
import { config } from 'util/config';

//创建包含多个Section的页面
export default class CreatePage extends React.Component {
  constructor(props) {
    super();
    this.state = {
      page: {},
      loaded: false
    }

    // this.child = React.createRef();
    this.child = [];
  }

  //查询该页面的config
  componentDidMount() {
    setTimeout(() => {
      if (!this.state.loaded) {
        this.getPageConfig();
      }
    }, config.setTimeoutMilliSecond);
  }

  getPageConfig() {
    let module = this.props.module !== undefined && this.props.module !== null ? this.props.module : '';
    let condition = this.props.condition !== undefined && this.props.condition !== null ? this.props.condition : null;
    let pageConfig = this.props.webUIConfig;
    if (pageConfig !== null) {
      this.setState({ page: pageConfig, loaded: true });
      this.props.pageComponent.setState({ page: pageConfig });
      pageConfig.sectionList.map((section, i) => {
        this.child.push(React.createRef());
      });
      this.setState({});
    }
    else {
      message.error('not found config, Area: ' + this.props.areaName + ', Module: ' + module + ', Page: ' + this.props.pageName + ', Condition: ' + condition);
    }
  }

  //根据页面下section的列表, 遍历生成每个Section
  createUI() {
    switch (this.state.page.type) {
      default:
        return this.state.page.sectionList.map((section, i) => <DefaultSection
          {...this.props}
          ref={this.child[i]}
          section={section}
          sectionName={section.name}
          key={i} />);
    }
  }

  render() {
    return (
      this.state.loaded ?
        <>{this.createUI()}</> :
        <div className="gx-loader-view gx-loader-position">
          <CircularProgress />
        </div>
    );
  }
}
